import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

function ContactForm() {
    const form = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    useEffect(() => {
        emailjs.init("yFHHm5gYw_7kvwR5K");
    }, []);

    const validateEmail = (e) => {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value) === false) {
            e.target.style.borderColor = '#ef4444';
        } else {
            e.target.style.borderColor = '#e2e8f0';
        }
    };
    
    const checkIfEmpty = (e) => {
        if (e.target.value.length <= 0) {
            e.target.style.borderColor = '#ef4444';
        } else {
            e.target.style.borderColor = '#e2e8f0';
        }
    };
    
    const handleSubmit = (e) => { 
        e.preventDefault();
    
        const name = form.current.name.value;
        const email = form.current.email.value;
        const subject = form.current.subject.value;
        const message = form.current.message.value;

        if (!name || !email || !subject || !message) {
            alert('All fields must be filled out before submitting.');
            return;
        }

        setIsSubmitting(true);
        setSubmitStatus(null);

        emailjs.sendForm(
            'service_xsdupem',
            'template_m3ibxbk',
            form.current
        )
            .then((result) => {
                setSubmitStatus('success');
                form.current.reset();
                alert('Thank you for your message. We will be in touch with you shortly.');
            })
            .catch((error) => {
                setSubmitStatus('error');
                alert('There was an error sending your message. Please try again later.');
                
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };
    
    return (
        <form ref={form} id="contact" onSubmit={handleSubmit}>
            
            <h3>Contact Form</h3>
            <p>
                Please submit any questions you may have for our office. For information about becoming a new patient,
                please visit our Patient Information page.
            </p>

            <div id="contact-info">
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                        onChange={checkIfEmpty}
                        type="text" 
                        id="name" 
                        name="name"
                        placeholder="Your name"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input 
                        onChange={validateEmail}
                        type="email"
                        id="email" 
                        name="email" 
                        placeholder="Your email"
                        required
                    />
                </div>
            </div>

            <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input 
                    onChange={checkIfEmpty}
                    type="text" 
                    id="subject" 
                    name="subject"
                    placeholder="Message subject"
                    required
                />
            </div>

            <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea 
                    onChange={checkIfEmpty}
                    id="message"
                    name="message"
                    placeholder="Your message"
                    required
                />
            </div>

            <button 
                type="submit" 
                disabled={isSubmitting}
                className="submit-button"
            >
                {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
        </form>
    );
}

export default ContactForm;
